import * as React from "react";
export const ContainerFW = (props) => (React.createElement("div", { style: {
        ...(props.backgroundColor
            ? { backgroundColor: props.backgroundColor }
            : {}),
    }, className: `g-container g-container--fullwidth${props.className ? ` ${props.className}` : ""}` }, props.children));
